import React from 'react'
import Profilemain from "../../contact/components/Profile"

const Profile = () => {
  return (
    <Profilemain />
  )
}

export default Profile